import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.parse-int.js";
import "core-js/modules/es.number.constructor.js";
import { LoadData, LoadListAdvancedQuery as _LoadListAdvancedQuery, SaveListAdvancedQuery as _SaveListAdvancedQuery, GetSelectPageList as _GetSelectPageList, GetSelectList } from '@/api/ListParam';
import { mapGetters } from 'vuex'; // 不需要参数值的操作类型

var NOT_VALUE_ACTION_TYPES = [8, 9];
export default {
  name: 'SeniorSearch',
  components: {
    MesTable: function MesTable() {
      return import('@/components/MesTable');
    },
    MesColumn: function MesColumn() {
      return import('@/components/MesColumn');
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      mainTable: [],
      loading: false,
      // 字段类型
      fieldList: [],
      // 操作类型
      actionList: [{
        value: 1,
        label: '等于(=)'
      }, {
        value: 2,
        label: '大于(>)'
      }, {
        value: 3,
        label: '大于等于(>=)'
      }, {
        value: 4,
        label: '小于(<)'
      }, {
        value: 5,
        label: '小于等于(<=)'
      }, {
        value: 6,
        label: '模糊搜索(like)'
      }, {
        value: 7,
        label: '不等于(!=)'
      }, {
        value: 8,
        label: '值为空(null)'
      }, {
        value: 9,
        label: '值不为空(!null)'
      }],
      // 参数类型
      parameterList: [{
        value: 1,
        label: '文本框'
      }, {
        value: 2,
        label: '下拉选择框'
      }, {
        value: 3,
        label: '数字'
      }, {
        value: 4,
        label: '日期'
      }],
      validRules: {
        PARAM_NAME: [{
          required: true,
          message: '请选择字段(参数名)'
        }]
      },
      // 分页表格配置
      dropdownFormData: {
        Page: 1,
        Limit: 15
      },
      dropdownLoading: false,
      dropdownSelect: false,
      dropdownTotalPage: 0,
      dropdownData: [],
      columnsWhere: [],
      // 下拉框数据
      optionData: [],
      isSave: true,
      actionIndx: -1
    };
  },
  computed: _objectSpread({}, mapGetters(['userinfo'])),
  methods: {
    test: function test() {
      console.log('日期change');
    },
    handleKeyupEvent: function handleKeyupEvent(row) {
      this.dropdownFormData.Key = row.PARAM_VALUE;
      this.GetSelectPageList();
    },
    handleDropFocus: function handleDropFocus(row, index) {
      this.actionIndx = index;
      this.dropdownFormData.PARAM_NAME = row.PARAM_NAME;
      this.GetSelectPageList();
      this.$refs.xDown.showPanel();
    },
    CellClick: function CellClick(_ref) {
      var row = _ref.row,
          $rowIndex = _ref.$rowIndex;
      var $table = this.$refs.xTable;

      var _$table$getTableData = $table.getTableData(),
          fullData = _$table$getTableData.fullData;

      fullData[this.actionIndx].PARAM_VALUE = row.CODE;
      this.$refs.xDown.hidePanel();
    },
    // 根据字段获取下拉数据
    GetSelectPageList: function GetSelectPageList() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dropdownLoading = true;
                _context.next = 3;
                return _GetSelectPageList(_this.dropdownFormData).catch(function (_) {
                  _this.dropdownLoading = false;
                });

              case 3:
                res = _context.sent;
                _this.dropdownLoading = false;

                if (res.Result) {
                  _this.dropdownData = res.Result || [];
                  _this.dropdownTotalPage = res.TotalCount;
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 下拉选择框
    handleParamListData: function handleParamListData(flag, row) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!flag) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 3;
                return GetSelectList({
                  PARAM_NAME: row.PARAM_NAME
                });

              case 3:
                res = _context2.sent;

                if (res.Result) {
                  _this2.optionData = res.Result;
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 下拉框选择
    handleSelectChange: function handleSelectChange(value, row) {
      console.log(value);
      console.log(row);
      row.PARAM_VALUE = value;
    },
    handleSizeChange: function handleSizeChange(Limit) {
      this.dropdownFormData.Limit = Limit;
      this.GetSelectPageList();
    },
    handleCurrentChange: function handleCurrentChange(Page) {
      this.dropdownFormData.Page = Page;
      this.GetSelectPageList();
    },
    // 自定义排序
    customSortMethod: function customSortMethod(_ref2) {
      var column = _ref2.column,
          property = _ref2.property,
          order = _ref2.order;
      var obj = {};

      if (order === 'asc') {
        obj.OrderBySort = 0;
      } else {
        obj.OrderBySort = 1;
      }

      var OrderBySort = obj.OrderBySort;
      this.dropdownFormData.OrderByParam = property;
      this.dropdownFormData.OrderBySort = OrderBySort;
      this.GetSelectPageList();
    },
    // 选择字段(参数名)
    paramChangeEvent: function paramChangeEvent(_ref3) {
      var row = _ref3.row,
          $rowIndex = _ref3.$rowIndex;
      this.actionIndx = $rowIndex;
      this.fieldList.map(function (item) {
        if (item.PARAM_NAME === row.PARAM_NAME) {
          row.FIELD_NAME = item.FIELD_NAME;
          row.DATA_TYPE = item.DATA_TYPE;
          row.ACTION_TYPE = item.ACTION_TYPE;
          row.IS_PAGING = item.IS_PAGING;
          row.PARAM_VALUE = item.PARAM_VALUE ? item.PARAM_VALUE : '';
        }
      });
    },
    // 点击搜索按钮
    searchClick: function searchClick() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var $table, errMap, _$table$getTableData2, fullData, tempData;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                $table = _this3.$refs.xTable;
                _context3.next = 3;
                return $table.validate().catch(function (errMap) {
                  return errMap;
                });

              case 3:
                errMap = _context3.sent;

                if (errMap) {
                  _context3.next = 15;
                  break;
                }

                _$table$getTableData2 = $table.getTableData(), fullData = _$table$getTableData2.fullData;

                if (!(fullData.length <= 0)) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return");

              case 8:
                tempData = [];
                fullData && fullData.map(function (item) {
                  if ( // 过滤参数值为空的选项（不包括值属于NOT_VALUE_ACTION_TYPES情况）
                  !['', null, undefined].includes(item.PARAM_VALUE) || NOT_VALUE_ACTION_TYPES.includes(item.ACTION_TYPE)) {
                    var obj = {};
                    obj.ORD_ID = item.ORD_ID;
                    obj.USER_NAME = _this3.userinfo.USER_NAME;
                    obj.PARAM_NAME = item.PARAM_NAME;
                    obj.FIELD_NAME = item.FIELD_NAME;
                    obj.ACTION_TYPE = item.ACTION_TYPE;
                    obj.PARAM_VALUE = item.PARAM_VALUE;
                    obj.DATA_TYPE = item.DATA_TYPE;
                    obj.IS_PAGING = item.IS_PAGING;
                    tempData.push(obj);
                  }
                });

                if (!(tempData.length > 0)) {
                  _context3.next = 14;
                  break;
                }

                // 同意保存
                if (_this3.isSave) {
                  console.log('tempData--', tempData);

                  _this3.SaveListAdvancedQuery(tempData);
                } else {
                  _this3.handleEmitParamList(tempData);
                }

                _context3.next = 15;
                break;

              case 14:
                return _context3.abrupt("return", _this3.$message({
                  message: '检测到暂无输入查询参数',
                  type: 'warning'
                }));

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 保存
    SaveListAdvancedQuery: function SaveListAdvancedQuery(tempData) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _SaveListAdvancedQuery(tempData);

              case 2:
                res = _context4.sent;

                if (res.Result) {
                  _this4.handleEmitParamList(tempData);
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    handleEmitParamList: function handleEmitParamList(data) {
      // this.$parent.handleParamList(data)
      this.$parent.handleSeniorSearch(data);
      this.dialogVisible = false;
    },
    // 清空按钮
    seniorSearchClear: function seniorSearchClear() {
      var $table = this.$refs.xTable;

      var _$table$getTableData3 = $table.getTableData(),
          fullData = _$table$getTableData3.fullData;

      fullData && fullData.map(function (item) {
        item.PARAM_VALUE = '';
      });
    },
    // 新增按钮
    seniorSearchAdd: function seniorSearchAdd() {
      var $table = this.$refs.xTable;

      var _$table$getTableData4 = $table.getTableData(),
          fullData = _$table$getTableData4.fullData;

      var maxIndex = Math.max.apply(Math, fullData.length <= 0 ? [0] : fullData.map(function (o) {
        return o.ORD_ID;
      })) + 1;
      var record = {
        ORD_ID: maxIndex,
        PARAM_NAME: '',
        ACTION_TYPE: 6,
        PARAM_VALUE: '',
        DATA_TYPE: 1
      };
      $table.insertAt(record);
    },
    handleSearchTableLoad: function handleSearchTableLoad() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.dialogVisible = true;

                _this5.handleLoadData();

                _this5.LoadListAdvancedQuery();

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 序列状态
    serializeStatus: function serializeStatus(PARAM_VALUE) {
      switch (PARAM_VALUE) {
        case '1':
          return '未处理';

        case '2':
          return '审核';

        case '3':
          return '作废';

        case '4':
          return '在途';

        case '5':
          return '收货';
      }
    },
    LoadListAdvancedQuery: function LoadListAdvancedQuery() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this6.loading = true;
                _context6.next = 3;
                return _LoadListAdvancedQuery({
                  USER_NAME: _this6.userinfo.USER_NAME
                }).catch(function (_) {
                  _this6.loading = false;
                });

              case 3:
                res = _context6.sent;
                console.log('mainTable res', res);
                _this6.loading = false;

                if (res.Result) {
                  // this.mainTable = res.Result || []
                  _this6.mainTable = res.Result.map(function (item) {
                    item._PARAM_VALUE = _this6.serializeStatus(item.PARAM_VALUE);
                    return item;
                  });
                  _this6.total = _this6.mainTable.length;
                }

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    handleLoadData: function handleLoadData() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var data, tempData;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return LoadData({
                  Page: 1,
                  Limit: 999
                });

              case 2:
                data = _context7.sent;

                if (data.Result) {
                  tempData = [{
                    PARAM_NAME: '',
                    PARAM_CAPTION: '',
                    FIELD_NAME: ''
                  }];
                  data.Result.map(function (item) {
                    var obj = {};
                    obj.PARAM_NAME = item.PARAM_NAME;
                    obj.PARAM_CAPTION = item.PARAM_CAPTION;
                    obj.FIELD_NAME = item.FIELD_NAME;
                    obj.DATA_TYPE = item.DATA_TYPE;
                    obj.ACTION_TYPE = item.ACTION_TYPE;
                    obj.IS_PAGING = item.IS_PAGING;
                    obj.IS_FAST_SEARCH = item.IS_FAST_SEARCH;
                    tempData.push(obj); // console.log('list', tempData)
                  });
                  _this7.fieldList = tempData; // 字段类型赋值

                  _this7.columnsWhere = tempData;
                }

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    handleColseSearch: function handleColseSearch() {
      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      // this.$parent.handleParamList()
      this.dialogVisible = flag;
    },
    removeClick: function removeClick(row) {
      var _this8 = this;

      this.$confirm('确定要删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this8.$refs.xTable.remove(row);
      });
    },
    handleActionType: function handleActionType(_ref4) {
      var row = _ref4.row;
      row.ACTION_TYPE = Number.parseInt(row.ACTION_TYPE);

      if (NOT_VALUE_ACTION_TYPES.includes(row.ACTION_TYPE)) {
        row.PARAM_VALUE = null;
      }
    },
    paramValueDisabled: function paramValueDisabled(row) {
      return NOT_VALUE_ACTION_TYPES.includes(row.ACTION_TYPE);
    }
  }
};